<!-- Sidebar Navigation Container -->
<div class="sidebar-navigation sidebar" [class.open]="isOpen" *ngIf="auth">
	<!-- Floating rounded nav panel -->
	<div class="sidebar-panel">
		<nav class="sidebar-nav" aria-label="Main navigation">
			<ul class="nav-menu">
				<!-- 1. Home -->
				<li class="nav-item" *ngIf="!isSimplified">
					<a
						class="nav-link"
						[routerLink]="['/dashboard']"
						[class.active]="isHomeActive()"
						[attr.aria-current]="isHomeActive() ? 'page' : null"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/dashboard',
							componentName: 'sidebar',
							id: 'sidebar-home',
							placement: 'sidebar-menu'
						}">
						<img src="assets/images/icons/SidebarV3Icons/Home.svg" alt="Home" class="nav-icon" width="24" height="24" />
						<span class="nav-text">{{ navHome }}</span>
					</a>
				</li>
				<li class="nav-item non-clickable" *ngIf="isSimplified">
					<div class="nav-link">
						<img src="assets/images/icons/SidebarV3Icons/Home.svg" alt="Home" class="nav-icon" width="24" height="24" />
						<span class="nav-text">{{ navHome }}</span>
					</div>
				</li>

				<!-- 2. My Health -->
				<li
					class="nav-item nav-group"
					*ngIf="isMatchedMember && !isSimplified"
					[class.active]="isMyHealthActive() || healthSectionExpanded">
					<div
						class="nav-link"
						role="button"
						tabindex="0"
						[attr.aria-expanded]="healthSectionExpanded"
						(click)="navigateToRecords()"
						(keydown.enter)="navigateToRecords()"
						(keydown.space)="navigateToRecords(); $event.preventDefault()"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/dashboard/my-health-dashboard',
							componentName: 'sidebar',
							id: 'sidebar-my-health',
							placement: 'sidebar-menu'
						}">
						<img
							src="assets/images/icons/SidebarV3Icons/Records.svg"
							alt="My Health"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navMyHealthAndData }}</span>
					</div>
				</li>
				<li class="nav-item non-clickable" *ngIf="!isMatchedMember || isSimplified">
					<div class="nav-link">
						<img
							src="assets/images/icons/SidebarV3Icons/Records.svg"
							alt="My Health"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navMyHealthAndData }}</span>
					</div>
				</li>

				<!-- 3. Visits -->
				<li class="nav-item" *ngIf="isMatchedMember && !isSimplified">
					<a
						class="nav-link"
						[routerLink]="['/scheduling/appointments']"
						[class.active]="isVisitsActive()"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/scheduling/appointments',
							componentName: 'sidebar',
							id: 'sidebar-appointments',
							placement: 'sidebar-menu'
						}">
						<span class="icon-wrapper">
							<img
								src="assets/images/icons/SidebarV3Icons/Visits.svg"
								alt="Visits"
								class="nav-icon"
								width="24"
								height="24" />
							<span class="icon-badge" *ngIf="appointmentCount > 0">{{ appointmentCount }}</span>
						</span>
						<span class="nav-text">{{ navVisits }}</span>
					</a>
				</li>
				<li class="nav-item non-clickable" *ngIf="!isMatchedMember || isSimplified">
					<div class="nav-link">
						<img
							src="assets/images/icons/SidebarV3Icons/Visits.svg"
							alt="Visits"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navVisits }}</span>
					</div>
				</li>

				<!-- 4. Health Coaching -->
				<li class="nav-item" *ngIf="canShowHealthCoaching() && isMatchedMember && !isSimplified">
					<a
						class="nav-link"
						[routerLink]="['/health/mentor']"
						[class.active]="isHealthCoachingActive()"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/health/mentor',
							componentName: 'sidebar',
							id: 'sidebar-health-coaching',
							placement: 'sidebar-menu'
						}">
						<img
							src="assets/images/icons/SidebarV3Icons/Coaching.svg"
							alt="Wellness Coaching"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navMyMentors }}</span>
					</a>
				</li>
				<li class="nav-item non-clickable" *ngIf="canShowHealthCoaching() && (!isMatchedMember || isSimplified)">
					<div class="nav-link">
						<img
							src="assets/images/icons/SidebarV3Icons/Coaching.svg"
							alt="Wellness Coaching"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navMyMentors }}</span>
					</div>
				</li>

				<!-- 5. Care Team -->
				<li class="nav-item" *ngIf="isMatchedMember && !isSimplified">
					<a
						class="nav-link"
						[routerLink]="['/care-team']"
						[class.active]="isCareTeamActive()"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/care-team',
							componentName: 'sidebar',
							id: 'sidebar-care-team',
							placement: 'sidebar-menu'
						}">
						<img
							src="assets/images/icons/SidebarV3Icons/CareTeam.svg"
							alt="Care Team"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navCareTeam }}</span>
					</a>
				</li>
				<li class="nav-item non-clickable" *ngIf="!isMatchedMember || isSimplified">
					<div class="nav-link">
						<img
							src="assets/images/icons/SidebarV3Icons/CareTeam.svg"
							alt="Care Team"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navCareTeam }}</span>
					</div>
				</li>

				<!-- 6. Messages -->
				<li class="nav-item" *ngIf="isMatchedMember && !isSimplified">
					<a
						class="nav-link"
						[routerLink]="['/messaging/mailbox/inbox']"
						[class.active]="isMessagesActive()"
						appEheAnalytics
						[data]="{
							pageUrl: '/dashboard',
							redirectedTo: '/messaging/mailbox/inbox',
							componentName: 'sidebar',
							id: 'sidebar-messages',
							placement: 'sidebar-menu'
						}">
						<span class="icon-wrapper">
							<mat-icon class="nav-icon">email</mat-icon>
							<span class="icon-badge" *ngIf="messagingService.getCurrentMessageCount().getValue()?.inbox > 0">
								{{ messagingService.getCurrentMessageCount().getValue()?.inbox }}
							</span>
						</span>
						<span class="nav-text">{{ navMessages }}</span>
					</a>
				</li>
				<li class="nav-item non-clickable" *ngIf="!isMatchedMember || isSimplified">
					<div class="nav-link">
						<mat-icon class="nav-icon">email</mat-icon>
						<span class="nav-text">{{ navMessages }}</span>
					</div>
				</li>
			</ul>
		</nav>

		<!-- Panel Footer: Profile, Contact, Sign Out / Sign In -->
		<div class="sidebar-footer">
			<!-- Profile -->
			<a
				*ngIf="!isSimplified"
				class="nav-link"
				[routerLink]="['/account']"
				[class.active]="isProfileActive()"
				[attr.aria-current]="isProfileActive() ? 'page' : null"
				appEheAnalytics
				[data]="{
					pageUrl: '/dashboard',
					redirectedTo: '/account',
					componentName: 'sidebar',
					id: 'sidebar-account',
					placement: 'sidebar-footer'
				}">
				<img
					src="assets/images/icons/SidebarV3Icons/Profile.svg"
					alt="Profile"
					class="nav-icon"
					width="24"
					height="24" />
				<span class="nav-text">{{ navProfile }}</span>
			</a>
			<div *ngIf="isSimplified" class="nav-link non-clickable">
				<img
					src="assets/images/icons/SidebarV3Icons/Profile.svg"
					alt="Profile"
					class="nav-icon"
					width="24"
					height="24" />
				<span class="nav-text">{{ navProfile }}</span>
			</div>
			<!-- Contact Us -->
			<a
				*ngIf="!isSimplified"
				class="nav-link"
				[routerLink]="['/faq/questions']"
				[class.active]="isContactUsActive()"
				[attr.aria-current]="isContactUsActive() ? 'page' : null"
				appEheAnalytics
				[data]="{
					pageUrl: '/dashboard',
					redirectedTo: '/faq/questions',
					componentName: 'sidebar',
					id: 'sidebar-help',
					placement: 'sidebar-footer'
				}">
				<img
					src="assets/images/icons/SidebarV3Icons/ContactUs.svg"
					alt="Contact Us"
					class="nav-icon"
					width="24"
					height="24" />
				<span class="nav-text">{{ navHelp }}</span>
			</a>
			<div *ngIf="isSimplified" class="nav-link non-clickable">
				<img
					src="assets/images/icons/SidebarV3Icons/ContactUs.svg"
					alt="Contact Us"
					class="nav-icon"
					width="24"
					height="24" />
				<span class="nav-text">{{ navHelp }}</span>
			</div>
			<div class="footer-divider"></div>
			<!-- Sign Out (normal) -->
			<div
				*ngIf="!isSimplified"
				class="nav-link logout-link"
				role="button"
				tabindex="0"
				(click)="logout()"
				(keydown.enter)="logout()"
				(keydown.space)="logout(); $event.preventDefault()"
				appEheAnalytics
				[data]="{
					pageUrl: '/dashboard',
					redirectedTo: '/login',
					componentName: 'sidebar',
					id: 'sidebar-logout',
					placement: 'sidebar-footer'
				}">
				<img
					src="assets/images/icons/SidebarV3Icons/Signout.svg"
					alt="Sign Out"
					class="nav-icon"
					width="24"
					height="24" />
				<span class="nav-text">{{ navSignOut }}</span>
			</div>
			<!-- Sign In (simplified) -->
			<a
				*ngIf="isSimplified"
				class="nav-link"
				[routerLink]="['/login']"
				[queryParams]="{ tab: 'login' }"
				appEheAnalytics
				[data]="{
					pageUrl: '/book',
					redirectedTo: '/login',
					componentName: 'sidebar',
					id: 'sidebar-sign-in',
					placement: 'sidebar-footer'
				}"
				appGoogleAnalytics
				[eventData]="{
					eventCategory: 'Link',
					eventAction: 'Sign-In',
					eventLabel: 'Simplified Booking - Sidebar Sign In'
				}">
				<mat-icon class="nav-icon">login</mat-icon>
				<span class="nav-text">{{ navSignIn }}</span>
			</a>
		</div>
	</div>
</div>

<!-- Mobile Overlay -->
<div class="sidebar-overlay" *ngIf="isOpen && isMobileOrTablet" (click)="onToggleSidebar()"></div>

<!-- Sidebar for non-authenticated users (simplified) -->
<div class="sidebar-navigation sidebar simplified" [class.open]="isOpen" *ngIf="!auth && isSimplified">
	<div class="sidebar-logo-area">
		<div class="logo-container" [routerLink]="['/']">
			<img src="assets/images/ehe_pulse_logo.svg" class="sidebar-logo" alt="EHE Logo" />
		</div>
	</div>
	<div class="sidebar-panel">
		<nav class="sidebar-nav" aria-label="Main navigation">
			<ul class="nav-menu">
				<!-- Home -->
				<li class="nav-item non-clickable">
					<div class="nav-link">
						<img src="assets/images/icons/SidebarV3Icons/Home.svg" alt="Home" class="nav-icon" width="24" height="24" />
						<span class="nav-text">{{ navHome }}</span>
					</div>
				</li>
				<!-- My Health -->
				<li class="nav-item non-clickable">
					<div class="nav-link">
						<img
							src="assets/images/icons/SidebarV3Icons/Records.svg"
							alt="My Health"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navMyHealthAndData }}</span>
					</div>
				</li>
				<!-- Visits -->
				<li class="nav-item non-clickable">
					<div class="nav-link">
						<img
							src="assets/images/icons/SidebarV3Icons/Visits.svg"
							alt="Visits"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navVisits }}</span>
					</div>
				</li>
				<!-- Health Coaching -->
				<li class="nav-item non-clickable">
					<div class="nav-link">
						<img
							src="assets/images/icons/SidebarV3Icons/Coaching.svg"
							alt="Wellness Coaching"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navMyMentors }}</span>
					</div>
				</li>
				<!-- Care Team -->
				<li class="nav-item non-clickable">
					<div class="nav-link">
						<img
							src="assets/images/icons/SidebarV3Icons/CareTeam.svg"
							alt="Care Team"
							class="nav-icon"
							width="24"
							height="24" />
						<span class="nav-text">{{ navCareTeam }}</span>
					</div>
				</li>
				<!-- Messages -->
				<li class="nav-item non-clickable">
					<div class="nav-link">
						<mat-icon class="nav-icon">email</mat-icon>
						<span class="nav-text">{{ navMessages }}</span>
					</div>
				</li>
			</ul>
		</nav>
		<div class="sidebar-footer">
			<!-- Profile -->
			<div class="nav-link non-clickable">
				<img
					src="assets/images/icons/SidebarV3Icons/Profile.svg"
					alt="Profile"
					class="nav-icon"
					width="24"
					height="24" />
				<span class="nav-text">{{ navProfile }}</span>
			</div>
			<!-- Contact Us -->
			<div class="nav-link non-clickable">
				<img
					src="assets/images/icons/SidebarV3Icons/ContactUs.svg"
					alt="Contact Us"
					class="nav-icon"
					width="24"
					height="24" />
				<span class="nav-text">{{ navHelp }}</span>
			</div>
			<div class="footer-divider"></div>
			<!-- Sign In -->
			<a
				class="nav-link"
				[routerLink]="['/login']"
				[queryParams]="{ tab: 'login' }"
				appEheAnalytics
				[data]="{
					pageUrl: '/book',
					redirectedTo: '/login',
					componentName: 'sidebar',
					id: 'sidebar-login',
					placement: 'sidebar-footer'
				}"
				appGoogleAnalytics
				[eventData]="{
					eventCategory: 'Link',
					eventAction: 'LogIn-to-Portal',
					eventLabel: 'BookSimplified - Sidebar Link - Login'
				}">
				<mat-icon class="nav-icon">login</mat-icon>
				<span class="nav-text">{{ navSignIn }}</span>
			</a>
		</div>
	</div>
</div>
